import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ResumenData } from '../../../../../../core/model/DataCart';
import { OrderArticulos } from '../../../../../../core/model/DataOrder';
import { ProductData } from '../../../../../../core/model/Product.model';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { CheckoutService } from '../../utils/services/checkout.service';
import { EventService } from '../../../../../../services/event.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-resumen',
  templateUrl: './resumen.component.html',
  styleUrls: ['./resumen.component.scss']
})
export class ResumenComponent implements OnInit {
  public resumen: ResumenData;
  public orderArticulos: OrderArticulos;
  public products: ProductData[];
  private unsubscribe$ = new Subject<void>();
  public render: boolean = true;
  private sunscribeRender: Subscription = null;

  constructor(
    private cartService: CartService,
    private checkout: CheckoutService,
    private eventService: EventService,
  ) { }

  ngOnInit(): void {
    // este subscribe es para el resumen
    this.cartService.resumen$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.resumen = data;
      localStorage.setItem('resumen-cart-login', JSON.stringify(data));
      this.eventService.send('sample_cart', this.resumen);
    });
    this.getProductsCart();
    this.orderArticulos = this.checkout.itemsOrder();

    this.sunscribeRender = this.eventService.get("renderBtn").subscribe((data: any) => {
      this.render = data.data
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.sunscribeRender) {
      this.sunscribeRender.unsubscribe();
    }
  }

  private getProductsCart = () => {
    this.products = JSON.parse(localStorage.getItem('items-cart-login'));
  }
}
